/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "Produktinfo";
var Access = "Zugriff";
var Account = "Konto";
var Actions = "Aktionen";
var Active = "Aktiv";
var Add = "Hinzufügen";
var Address = "Adresse";
var Advanced = "Erweitert";
var Aliases = "Aliasnamen";
var all = "Alle";
var All = "Alle";
var Apply = "Übernehmen";
var April = "April";
var Arbitrary = "Beliebig";
var Assign = "Zuweisen";
var August = "August";
var Back = "Zurück";
var Basic = "Grundlegend";
var BNPP_EU = "BNPP_EU";
var Cancel = "Abbrechen";
var Category = "Kategorie";
var Classic = "Klassisch";
var Clear = "Löschen";
var CLI = "Befehlszeilenschnittstelle";
var Close = "Schließen";
var Clusters = "Cluster";
var code = "Code";
var Complete = "Abgeschlossen";
var Completed = "Abgeschlossen";
var Compliance = "Compliance";
var Compliant = "Konform";
var Configuration = "Konfiguration";
var Configure = "Konfigurieren";
var Confirm = "Bestätigen";
var Connect = "Connect";
var Connected = "Verbunden";
var Connecting = "Verbindungen herstellen";
var Containers = "Container";
var Country = "Land";
var Create = "Erstellen";
var Created = "Erstellungsdatum";
var Creating = "Wird erstellt";
var Critical = "Kritisch";
var Current = "Aktuell";
var Custom = "Angepasst";
var Dallas = "Dallas";
var Datacenter = "Rechenzentrum";
var Datacenters = "Rechenzentren";
var December = "Dezember";
var Delete = "Löschen";
var Deleting = "Wird gelöscht";
var Deploying = "Implementieren";
var Disabled = "Inaktiviert";
var Disconnect = "Verbindung trennen";
var Docs = "Dokumente";
var Documentation = "Dokumentation";
var Done = "Done";
var Download = "Herunterladen";
var Draft = "Entwurf";
var Edit = "Bearbeiten";
var Enabled = "Aktiviert";
var Encryption = "Verschlüsselung";
var End = "Ende";
var Enterprise = "Enterprise";
var Establish = "Entwicklung";
var Expired = "Abgelaufen";
var Failed = "Fehlgeschlagen";
var February = "Februar";
var Filter = "Filter";
var Filters = "Filter";
var Finalizing = "Endbearbeitung";
var Frankfurt = "Frankfurt";
var Free = "Kostenfrei";
var Friday = "Freitag";
var Geography = "Geografische Region";
var Help = "Hilfe";
var hour = "Stunde";
var Hour = "Stunde";
var hr = "Std.";
var IAM = "IAM";
var ID = "ID";
var Images = "Images";
var Inactive = "Inaktiv";
var Incomplete = "Unvollständig";
var Information = "Informationen";
var Infrastructure = "Infrastruktur";
var Instance = "Instanz";
var Instances = "Instanzen";
var Integrations = "Integrationen";
var Invalid = "Ungültig";
var January = "Januar";
var July = "Juli";
var June = "Juni";
var Key = "Schlüssel";
var Launch = "Starten";
var Lite = "Lite";
var Loading = "Ladevorgang";
var Location = "Standort";
var Locations = "Standorte";
var Logging = "Protokollierung";
var London = "London";
var March = "März";
var May = "Mai";
var Metro = "Metro";
var Minute = "Minute";
var mo = "mo";
var Monday = "Montag";
var Monitoring = "Monitoring";
var Month = "Monat";
var more = "Mehr";
var Name = "Name";
var Namespace = "Namensbereich";
var Namespaces = "Namensbereiche";
var Next = "Weiter";
var No = "Nein";
var None = "Keine";
var Normal = "Normal";
var Note = "Anmerkung";
var Notification = "Notification";
var November = "November";
var Objects = "Objekte";
var October = "Oktober";
var Off = "Aus";
var OK = "OK";
var On = "Ein";
var Open = "Offen";
var Osaka = "Osaka";
var Overview = "Übersicht";
var Packages = "Pakete";
var Pattern = "Muster";
var Pending = "Anstehend";
var Plan = "Planen";
var Premium = "Prämie";
var Previous = "Zurück";
var Product = "Produkt";
var Products = "Produkte";
var Project = "Projekt";
var Projects = "Projekte";
var Property = "Eigenschaft";
var provided = "bereitgestellt";
var Provider = "Provider";
var Provisioning = "Bereitstellung";
var Ready = "Bereit";
var Refresh = "Aktualisieren";
var region = "Bereich";
var Region = "Bereich";
var Remove = "Entfernen";
var Renew = "Erneuern";
var Repositories = "Repositorys";
var Requested = "Angefordert";
var Required = "Erforderlich";
var Reservations = "Reservierungen";
var Reset = "Zurücksetzen";
var resources = "Ressourcen";
var Resources = "Ressourcen";
var Results = "Ergebnisse";
var Review = "Prüfen";
var Routing = "Routing";
var Satellite = "Satellite";
var Saturday = "Samstag";
var Save = "Speichern";
var Scanning = "Scannen";
var Schedule = "Planen";
var Search = "Suchen";
var Secret = "Geheimer Schlüssel";
var Select = "Wählen";
var Sending = "Senden";
var September = "September";
var Serverless = "Serverunabhängig";
var Service = "Service";
var Settings = "Einstellungen";
var Size = "Größe";
var Sort = "Sortieren";
var Source = "Quelle";
var Start = "Starten";
var State = "Status";
var Status = "Status";
var Storage = "Speicher";
var Submit = "Übergeben";
var Subscription = "Abonnement";
var Success = "Erfolg";
var Summary = "Zusammenfassung";
var Sunday = "Sonntag";
var Sydney = "Sydney";
var tag = "Tag";
var tags = "Tags";
var Tags = "Tags";
var Thursday = "Donnerstag";
var Tokyo = "Tokio";
var Topics = "Themen";
var Toronto = "Toronto";
var Total = "Gesamtbetrag";
var Trash = "Papierkorb";
var Trial = "Test";
var Tuesday = "Dienstag";
var Unknown = "Unbekannt";
var Unsupported = "Nicht unterstützt";
var Update = "Aktualisieren";
var Upgrade = "Upgrade durchführen";
var Value = "Wert";
var Values = "Werte";
var Version = "Version";
var View = "Anzeigen";
var Warning = "Warnung";
var Wednesday = "Mittwoch";
var Workloads = "Workloads";
var Yes = "Ja";
var Zone = "Zone";
var Zones = "Zonen";
var de = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}' existiert bereits. Einen anderen Namen eingeben.",
	"'Day of week' matches in addition to 'Day of month'": "\"Tag der Woche\" entspricht zusätzlich \"Tag des Monats\"",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "\"Tag der Woche\" entspricht zusätzlich \"Tag des Monats\". Der Ausdruck wird jeden Tag ausgelöst.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} Elemente ausgewählt",
	"{{count}} resources": "{{count}} Ressourcen",
	"{{count}} resources included": "{{count}} enthaltene Ressourcen",
	"{{current}} of {{total}} pages": "{{current}} von {{total}} Seiten",
	"{{datahookName}} response": "{{datahookName}}-Antwort",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}}-Muster",
	"{{min}}–{{max}} items": "{{min}} – {{max}} Elemente",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} von {{total}} Elementen",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} Module, {{resourcesCount}} Ressourcen",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} erfordert die folgende(n) Option(en), um eingesetzt werden zu können.",
	"{{price}} per {{unit}}": "{{price}} pro {{unit}}",
	"{{price}} per month": "{{price}} pro Monat",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/M.",
	"{{resourcesCount}} resources": "{{resourcesCount}} Ressourcen",
	"{{rolesCount}} Role": "{{rolesCount}} Rolle",
	"{{rolesCount}} Roles": "{{rolesCount}} Rollen",
	"{{topicsCount}} topic active for this instance.": "{{topicsCount}} Thema aktiv für diese Instanz.",
	"{{topicsCount}} topics active for this instance.": "{{topicsCount}} für diese Instanz aktive Themen.",
	"{{value}} percent status progress": "{{value}} Prozent Statusfortschritt",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (einen neuen Cluster erstellen, um diese Betaversion zu testen)",
	"{{version}} (update to an earlier version first)": "{{version}} (zuerst eine Aktualisierung auf eine frühere Version durchführen)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Für die Erstellung eines Satellite-Standorts ist eine Cloud Object Storage-Instanz erforderlich.</span> <a>Weitere Informationen.</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / Instanz",
	"1 item selected": "1 Element ausgewählt",
	"1 of 1 page": "1 von 1 Seite",
	"1 role": "1 Rolle",
	"1–1 of 1 item": "1 – 1 von 1 Element",
	"A collection of keys that belong to your service instance.": "Eine Sammlung von Schlüsseln, die zu Ihrer Serviceinstanz gehören.",
	"A key can only have 5 aliases.": "Ein Schlüssel kann nur 5 Aliasnamen haben.",
	"A Key Protect key": "Ein Key Protect-Schlüssel",
	"A location name is required. ": "Ein Standortname ist erforderlich. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "Ein Multi-Tenant-Schlüsselmanagementservice. Erstellen und verwalten Sie Verschlüsselungsschlüssel, um Daten in Ihren Anwendungen zu verschlüsseln und den Zugriff auf die Daten zu steuern.",
	"A name is required.": "Ein Name ist erforderlich.",
	"A rotation policy of 12 months is recommended": "Eine Rotationspolitik von 12 Monaten wird empfohlen",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "Eine Dienst-zu-Dienst-Autorisierung ist zwischen {{sourceServiceDisplayName}} und {{serviceDisplayName}} erforderlich, um den Verschlüsselungsschlüssel zuzuordnen. Key Protect wird mit Ihrer Zustimmung einen solchen erstellen. Sie können sie auch manuell erstellen.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "Ein Single-Tenant-Schlüsselmanagementservice. Erstellen und verwalten Sie Verschlüsselungsschlüssel mit Schlüssel-Vaulting, das durch ein dediziertes, kundengesteuertes Hardwaresicherheitsmodul (HSM)bereitgestellt wird. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "Ein Tag darf nur alphanumerische Zeichen, Leerzeichen, Unterstreichungszeichen und Punkte sowie höchstens einen Doppelpunkt enthalten.",
	"A tag cannot end with a colon.": "Ein Tag darf nicht auf einen Doppelpunkt enden.",
	"A tag cannot include more than 128 characters.": "Ein Tag darf nicht mehr als 128 Zeichen enthalten.",
	"A tag cannot start with a colon.": "Ein Tag darf nicht mit einem Doppelpunkt beginnen.",
	"A tag should not have spaces around a colon.": "Ein Tag darf keine Leerzeichen um einen Doppelpunkt enthalten.",
	About: About,
	Access: Access,
	"Access management tags": "Zugriffsverwaltungstags",
	"Access management tags (optional)": "Zugriffsmanagementtags (optional)",
	"Access management tags help you apply flexible access policies on specific resources.": "Mithilfe von Zugriffsverwaltungstags können Sie flexible Zugriffsrichtlinien für bestimmte Ressourcen anwenden.",
	Account: Account,
	"Account type": "Kontotyp",
	"Action required": "Aktion erforderlich",
	Actions: Actions,
	Active: Active,
	"Active promotions": "Aktive Werbeaktionen",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "Die Ereignissammlung des Activity Trackers ist für diese Ressource aktiviert und wird an die in der Routing-Konfiguration festgelegten Ziele gesendet.",
	"Activity tracker events": "Activity Tracker-Ereignisse",
	"Activity tracking": "Aktivitätsverfolgung",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "Einen oder mehrere Namensbereiche zur Liste Ihrer spezifischen Namensbereiche hinzufügen.",
	"Add a single project or multiple projects to your specific project's list.": "Ein oder mehrere Projekte zur Liste Ihrer spezifischen Projekte hinzufügen.",
	"Add Activity tracker event collection": "Ereignissammlung Activity Tracker hinzufügen",
	"Add activity tracking": "Aktivitätsverfolgung hinzufügen",
	"Add event collection": "Ereignissammlung hinzufügen",
	"Add hosts": "Hosts hinzufügen",
	"Add hosts to meet the minimum service requirements.": "Fügen Sie Hosts hinzu, um die Mindestserviceanforderungen zu erfüllen.",
	"Add key alias (optional)": "Schlüsselalias hinzufügen (optional)",
	"Add key description (optional)": "Beschreibung des Schlüssels hinzufügen (optional)",
	"Add logging": "Protokollierung hinzufügen",
	"Add monitoring": "Überwachung hinzufügen",
	"Add namespace": "Namensbereich hinzufügen",
	"Add New": "Neu hinzufügen",
	"Add project": "Projekt hinzufügen",
	"Add storage": "Speicher hinzufügen",
	"Add tags": "Tags hinzufügen",
	"Add to estimate": "Zu Schätzung hinzufügen",
	"Add to existing": "Zu vorhandenem hinzufügen",
	"Add to project": "Zum Projekt hinzufügen",
	"Adding ...": "Hinzufügen ...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "Führen Sie die folgenden erforderlichen Aktionen aus, um Ihren Service erfolgreich bereitzustellen. Sie können diese Schritte jetzt oder nach der Erstellung des Service vervollständigen.",
	"Address field": "Adressfeld",
	Advanced: Advanced,
	"Advanced options": "Erweiterte Optionen",
	"After connection": "Nach Verbindung",
	"After the service cluster is created, assign storage to the cluster.": "Nachdem der Service-Cluster erstellt wurde, ordnen Sie dem Cluster Speicher zu.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Nach dem Trennen von Event Notifications wird die {{serviceName}}-Instanz aus der Liste der Quelldienste in der Event Notifications-Instanz entfernt.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "Aliase dürfen nur alphanumerische Zeichen und -_ enthalten.",
	"Aliases must be at least 2 characters and at most 90 characters.": "Aliasnamen müssen mindestens 2 Zeichen und dürfen höchstens 90 Zeichen lang sein.",
	all: all,
	All: All,
	"All audit events (default target)": "Alle Prüfungsereignisse (Standardziel)",
	"All audit events from your account will be sent to a new instance": "Alle Prüfungsereignisse von Ihrem Konto werden an eine neue Instanz gesendet",
	"All audit events from your account will be sent to an existing instance": "Alle Prüfungsereignisse von Ihrem Konto werden an eine bestehende Instanz gesendet",
	"All namespaces": "Alle Namensbereiche",
	"All namespaces not supported": "Alle Namensbereiche ohne Unterstützung",
	"All platform logs": "Alle Plattformprotokolle",
	"All prerequisite services are installed on the location.": "Alle vorausgesetzten Services werden an der Position installiert.",
	"All projects": "Alle Projekte",
	"All projects not supported": "Alle Projekte ohne Unterstützung",
	"All regions": "Alle Regionen",
	"All resource groups": "Alle Ressourcengruppen",
	"All secret groups": "Alle Gruppen geheimer Schlüssel",
	"All types": "Alle Typen",
	"All zone names must be unique": "Alle Zonennamen müssen eindeutig sein.",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "Zulässige Aktionen für die Rolle {{roleName}} ({{actionCount}})",
	"Already have an account? <a>Log in</a>": "Schon ein Konto? <a>Anmelden</a>",
	"An error occurred when fetching secrets. Try again later.": "Beim Abrufen von geheimen Schlüsseln ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
	"An instance of Event Notifications <a>Create new instance</a>": "Eine Instanz von Event Notifications <a>Neue Instanz erstellen</a>",
	"An unexpected error occurred.": "Ein unerwarteter Fehler ist aufgetreten.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Analysieren und Verwalten von Protokollen zur schnellen Problemlösung und proaktiven Vermeidung von Ausfallzeiten. <a>Weitere Informationen</a>",
	Apply: Apply,
	"Apply a code": "Code anwenden",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "Sind Sie sicher, dass Sie die Instanz {{serviceName}} von der Instanz \"{{ENInstanceName}}\" trennen wollen?",
	"Are you sure you want to close the side panel?": "Soll der seitliche Bereich tatsächlich geschlossen werden?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "Möchten Sie diese Anzeige wirklich schließen? Alle von Ihnen getroffenen Auswahlen gehen verloren.",
	"Are you sure?": "Sind Sie sicher?",
	Assign: Assign,
	"Associate key": "Schlüssel zuordnen",
	"Attachment name": "Zuordnungsname",
	"Audit event collection is already enabled for this resource": "Die Erfassung von Audit-Ereignissen ist für diese Ressource bereits aktiviert",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "Die Erfassung von Audit-Ereignissen wird für eine optimale Fehlerbehebung und die Reduzierung von Ausfallzeiten empfohlen",
	"Audit events (error)": "Audit-Ereignisse (Fehler)",
	"Audit events from {{region}} will be sent to a new instance": "Audit-Ereignisse von {{region}} werden an eine neue Instanz gesendet",
	"Audit events from {{region}} will be sent to an existing instance": "Audit-Ereignisse von {{region}} werden an eine bestehende Instanz gesendet",
	"Audit events in {{region}}": "Prüfungsereignisse in {{region}}",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "Audit-Ereignisse werden von aktivierten IBM Cloud-Diensten entsprechend dem definierten Routing-Bereich gesammelt.",
	"Audit events...": "Audit-Ereignisse...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "Es ist eine Authentifizierung erforderlich oder Sie verfügen nicht über die korrekten Berechtigungen zur Durchführung dieser Aktion.",
	"Authorization error": "Berechtigungsfehler",
	"Authorization met": "Autorisierung erfüllt",
	"Authorization needed": "Autorisierung erforderlich",
	"Authorize now": "Jetzt autorisieren",
	"Authorizing...": "Ermächtigung...",
	Back: Back,
	"Base URI": "Basis-URI",
	"Base64 encoded key material": "Base64 kodiertes Schlüsselmaterial",
	Basic: Basic,
	"Before you begin": "Vorbereitende Schritte",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "Bevor Ihr Projekt Konfigurationen validieren oder implementieren kann, muss der Projektservice in diesem Konto für die Kommunikation mit Schematics, Catalog Management, Secrets Manager und Resource Controller autorisiert werden. Ein Benutzer mit dem erforderlichen Zugriff auf diese Services kann automatisch Berechtigungen erteilen, indem er ein Projekt in diesem Konto erstellt, oder er kann den Service für Serviceautorisierungen manuell erstellen. Diese Berechtigung ist nur einmal erforderlich.",
	"Billing information": "Abrechnungsinformationen",
	"Billing period": "Abrechnungszeitraum",
	BNPP_EU: BNPP_EU,
	"Bucket name": "Gruppierungsname",
	"By {{name}}": "Durch {{name}}",
	"By clicking Save, you are creating the following access:": "Durch Klicken auf 'Speichern' erstellen Sie den folgenden Zugriff:",
	"Can't retrieve details": "Abrufen der Details nicht möglich.",
	Cancel: Cancel,
	"Cannot list integrations!": "Auflisten der Integrationen nicht möglich.",
	"Cannot view keys in this instance": "Schlüssel in dieser Instanz können nicht angezeigt werden",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "Es fallen Gebühren an. <a>Weitere Informationen</a>",
	"Choose a cluster version": "Clusterversion auswählen",
	"Choose a key ring": "Wählen Sie einen Schlüsselring aus",
	"Choose a resource group": "Ressourcengruppe auswählen",
	"Choose account...": "Konto auswählen ...",
	"Choose an existing HPCS instance.": "Wählen Sie eine vorhandene HPCS-Instanz.",
	"Choose an existing Key Protect instance.": "Wählen Sie eine vorhandene Key Protect-Instanz aus.",
	"Choose an instance": "Eine Instanz auswählen",
	"Choose an option": "Wählen Sie eine Option aus",
	"Choose category...": "Kategorie auswählen...",
	"Choose location": "Speicherort auswählen",
	"Choose plan": "Plan auswählen",
	"Choose property...": "Eigenschaft auswählen...",
	"Choose provider...": "Provider auswählen ...",
	"Choose secret...": "Geheimen Schlüssel auswählen ...",
	"Choose service instance...": "Serviceinstanz auswählen ...",
	"Choose source name...": "Quellennamen auswählen...",
	"Choose source...": "Quelle auswählen...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "Wählen Sie die IBM Cloud Monitoring-Instanz aus, die Plattformmetriken von aktivierten Serviceinstanzen in IBM Cloud erhalten soll.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "Wählen Sie die IBM Log Analysis-Instanz aus, die Plattformprotokolle von aktivierten Serviceinstanzen in IBM Cloud erhalten soll.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "Alle aufheben",
	"Clear all selected items": "Auswahl aller ausgewählten Elemente aufheben",
	"Clear filters": "Filter aufheben",
	"Clear selected": "Auswahl löschen",
	"Clear selected item": "Auswahl des ausgewählten Elements aufheben",
	"Clear selection": "Auswahl aufheben",
	CLI: CLI,
	Close: Close,
	"Close menu": "Menü schließen",
	"Close page navigation menu": "Seitennavigationsmenü schließen",
	"Close Panel": "Anzeige schließen",
	"Close Push Panel": "Push-Anzeige schließen",
	"Closing side panel": "Seitlichen Bereich schließen",
	"Cloud Logs": "Cloudprotokolle",
	"Cloud Logs instance": "Cloud Logs-Instanz",
	"Cloud Logs instance name": "Name der Cloud Logs-Instanz",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Cloud Object Storage-Instanz",
	"Cluster \"{{name}}\" is being deleted.": "Der Cluster \"{{name}}\" wird gelöscht.",
	"Cluster management": "Clusterverwaltung",
	"Cluster version": "Clusterversion",
	"Cluster version cannot be updated.": "Clusterversion kann nicht aktualisiert werden.",
	Clusters: Clusters,
	code: code,
	"Code sample": "Codebeispiel",
	"Collapse all rows": "Alle Zeilen ausblenden",
	"Collapse group": "Gruppe ausblenden",
	"Collapse row": "Zeile ausblenden",
	"Collapse summary": "Zusammenfassung ausblenden",
	"Compact (24px)": "Kompakt (24 px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "Konfigurationsdetails",
	"Configuration name": "Konfigurationsname",
	Configure: Configure,
	"Configure activity tracking": "Aktivitätsüberwachung konfigurieren",
	"Configure encryption": "Verschlüsselung konfigurieren",
	"Configure logging": "Protokollierung konfigurieren",
	"Configure monitoring": "Überwachung konfigurieren",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Verbindung zu Event Notifications herstellen",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "Verbinden Sie Ihre {{serviceName}} Instanz mit einer bestehenden Event Notifications Instanz.",
	Connected: Connected,
	"Connected instance": "Verbundene Instanz",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "Verbundene Instanz von Event Notifications ist nicht vorhanden. Wenden Sie sich an den zuständigen Administrator.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Bitten Sie Ihren Kontoadministrator den Zugriff auf einen Plan für die Implementierung von Key Protect freizugeben.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Bitten Sie Ihren Kontoadministrator den Zugriff auf eine Ressourcengruppe für die Implementierung von Key Protect freizugeben.",
	"Contact your administrator for access.": "Wenden Sie sich an den zuständigen Administrator und fordern Sie die Zugriffsberechtigung an.",
	"Contact your administrator for additional assistance.": "Wenden Sie sich an den zuständigen Administrator und fordern Sie weitere Unterstütuzung an.",
	"Container registry": "Container-Registry",
	Containers: Containers,
	"Copied to clipboard": "In Zwischenablage kopieren",
	"Copy to clipboard": "In Zwischenablage kopieren",
	"Cost details": "Kostendetails",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "Preisinformationen konnten nicht geladen werden. Aktualisieren Sie die Seite oder wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.",
	Country: Country,
	Create: Create,
	"Create a key": "Schlüssel erstellen",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Erstellen Sie ein Ziel für die Weiterleitung von Protokollen, um die Protokollverwaltung und -analyse für eine schnelle Problemlösung und die proaktive Vermeidung von Ausfallzeiten zu unterstützen. <a>Weitere Informationen</a>",
	"Create a new instance to get started.": "Erstellen Sie eine neue Instanz, um loszulegen.",
	"Create a project": "Projekt erstellen",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Erstellen Sie einen Satellite-Standort, um IBM Cloud überall zu nutzen. Weitere Informationen finden Sie in der <a>Dokumentation</a>.",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Erstellen Sie ein Activity Tracker-Ereignis-Routing-Ziel und eine Route zur Unterstützung der Überwachung und Prüfung von IBM Cloud-Aktivitäten für verbesserte Sicherheit und Compliance. <a>Weitere Informationen</a>",
	"Create an encryption key or import your own key.": "Erstellen Sie einen Verschlüsselungsschlüssel oder importieren Sie Ihren eigenen Schlüssel.",
	"Create cluster": "Cluster erstellen",
	"Create failed": "Erstellen fehlgeschlagen",
	"Create instance": "Instanz erstellen",
	"Create location": "Standort erstellen",
	"Create new": "Neue erstellen",
	"Create new instance": "Neue Instanz erstellen",
	"Create new key": "Neuen Schlüssel erstellen",
	"Create new secret": "Neuen geheimen Schlüssel erstellen",
	"Create reference": "Referenz erstellen",
	"Create resource": "Ressource erstellen",
	"Create Satellite location": "Satellite-Position erstellen",
	"Create secret": "Geheimen Schlüssel erstellen",
	"Create services": "Services erstellen",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Erstellen Sie Themen, Ziele und Abonnements in Event Notifications, um über Ereignisse benachrichtigt zu werden, die von Ihrem {{serviceName}} erzeugt werden",
	Created: Created,
	Creating: Creating,
	"Creating ...": "Erstellung läuft...",
	"Creating...": "Erstellung läuft...",
	Critical: Critical,
	"CRON expression": "CRON-Ausdruck",
	Current: Current,
	Custom: Custom,
	"Custom access": "Angepasster Zugriff",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Datahook-Argumentblock",
	"Datahook Params": "Datahook-Parameter",
	"Datahook response": "Datahook-Antwort",
	"Day of month": "Tag des Monats",
	"Day of Month (UTC)": "Tag des Monats (UTC)",
	"Day of week": "Wochentag",
	"Day of week (UTC)": "Wochentag (UTC)",
	December: December,
	"Dedicated hosts": "Dedizierte Hosts",
	"Default target": "Standardziel",
	"Default title": "Standardtitel",
	"Define project details": "Projektdetails definieren",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "Definieren Sie die wiederholt auftretenden Ablaufsteuerungen der von diesem Ereignis generierten Ereignisse. Wählen Sie ein vordefiniertes Muster aus und passen Sie es an Ihre Anforderungen an. Zeitpläne werden in koordinierter Weltzeit (UTC) angegeben.",
	"Define the scope of audit events collected": "Definition des Umfangs der erfassten Prüfungsereignisse",
	Delete: Delete,
	"Delete cluster": "Cluster löschen",
	"Delete failed": "Löschen fehlgeschlagen",
	"Delete retry wait": "Wartezeit für Löschwiederholung",
	"Delete the persistent storage used by this cluster": "Den von diesem Cluster verwendeten persistenten Speicher löschen",
	Deleting: Deleting,
	"Deleting...": "Löschvorgang läuft...",
	"Deploy failed": "Bereitstellen fehlgeschlagen",
	"Deploy retry wait": "Wiederholungswartezeit für Implementierung",
	Deploying: Deploying,
	"Deployment ready": "Implementierung bereit",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "Veraltete Version; die Unterstützung endet {{when}}. Aktualisieren Sie die Version, damit Sie auch weiterhin Unterstützung erhalten.",
	"Description (optional)": "Beschreibung (optional)",
	"Description of the source": "Beschreibung der Quelle",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Event Notifications trennen",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "DNS-Unterdomainbezeichnungen dürfen maximal {{maxLength}} Zeichen umfassen.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "Bearbeitung abgeschlossen",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "Während der Aktualisierung werden der Cluster-Master, die Workerknoten, die Apps und die Ressourcen weiterhin ausgeführt. Nach dem Abschluss der Aktualisierung können Sie die Workerknotenversionen aktualisieren. Anweisungen und weitere Informationen zu den Unterschieden zwischen den Versionen <a>finden Sie in der Dokumentation</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Integration von Aktivitätstrackern bearbeiten",
	"Edit Array": "Array bearbeiten",
	"Edit columns": "Spalten bearbeiten",
	"Edit configuration": "Konfiguration bearbeiten",
	"Edit details": "Details bearbeiten",
	"Edit JSON": "JSON bearbeiten",
	"Edit logging integration": "Integration der Bearbeitungsprotokollierung",
	"Edit secure value": "Sicheren Wert bearbeiten",
	"Edit tags": "Tags bearbeiten",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Aktivieren Sie Lebenszyklus-Benachrichtigungen für Ihre {{serviceName}}-Instanz, indem Sie eine Event Notifications-Dienstinstanz anschließen.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "Ermöglicht die Überwachung, Konformität und Prüfung des Betriebs und des Risikos zur Verwaltung Ihres IBM Cloud-Kontos.",
	Encryption: Encryption,
	"Encryption key associated": "Verschlüsselungsschlüssel zugeordnet",
	"Encryption options menu": "Menü Verschlüsselungsoptionen",
	End: End,
	"End date": "Enddatum",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "Sie können die Schematics-Umgebung mit Integrationen erweitern. Beginnen Sie noch heute mit dem Hinzufügen von Integrationen, indem Sie eine der nachfolgend aufgeführten Optionen auswählen.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "Geben Sie einen Namen für die Konfiguration der bereitstellbaren Architektur ein.  Beispiel: production-vpc",
	"Enter a password": "Kennwort eingeben",
	"Enter a valid CRN": "Geben Sie eine gültige CRN ein",
	"Enter array values. Quotations are added to values after you save.": "Geben Sie Array-Werte ein. Anführungszeichen werden Werten nach dem Speichern hinzugefügt.",
	"Enter name and description": "Name und Beschreibung eingeben",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "Namen für die Hostzonen eingeben. Für eine Hochverfügbarkeitskonfiguration ordnen Sie die Hosts verteilt über diese drei Zonen zu; als Basis dienen die Infrastrukturproviderzonen. <a>Wofür werden Zonen benötigt?</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "Mehrere Namensbereiche durch Kommas getrennt eingeben. Wenn Sie auf 'Hinzufügen' klicken, werden die neuen Namensbereiche in die Liste aufgenommen und automatisch ausgewählt.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "Mehrere Projekte durch Kommas getrennt eingeben. Wenn Sie auf 'Hinzufügen' klicken, werden die neuen Projekte in die Liste aufgenommen und automatisch ausgewählt.",
	"Enter source name": "Quellennamen eingeben",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Geben Sie den exakten Namen eines vorhandenen Buckets in der Cloud Object Storage-Instanz ein. Wenn kein Name angegeben wird, wird ein neues Bucket erstellt.",
	Enterprise: Enterprise,
	"Entire secret": "Gesamter geheimer Schlüssel",
	"Environment (optional)": "Umgebung (optional)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "Umgebungen können Eigenschaften enthalten, die in zusammengehörigen Konfigurationen gemeinsam genutzt werden. Innerhalb der Konfiguration können Sie alle Werte überschreiben, die von der Umgebung bereitgestellt werden. <a>Weitere Informationen</a>",
	"Error": "Fehler",
	"Error checking existing services status": "Fehler beim Überprüfen des Status der vorhandenen Services",
	"Error checking host status": "Fehler beim Überprüfen des Hoststatus",
	"Error checking storage status": "Fehler beim Überprüfen des Speicherstatus",
	"Error fetching tags": "Fehler beim Abrufen von Tags",
	"Error icon": "Fehlersymbol",
	"Error loading accounts": "Fehler beim Laden von Konten",
	"Error loading categories": "Fehler beim Laden von Kategorien",
	"Error loading groups": "Fehler beim Laden von Gruppen",
	"Error loading instances": "Fehler beim Laden von Instanzen",
	"Error loading keys": "Fehler beim Laden der Schlüssel",
	"Error loading pricing": "Fehler beim Laden der Preisstruktur",
	"Error loading properties": "Fehler beim Laden von Eigenschaften",
	"Error loading providers": "Fehler beim Laden der Provider",
	"Error loading regions": "Fehler beim Laden der Regionen",
	"Error loading resource groups": "Fehler beim Laden der Ressourcengruppen",
	"Error loading S2S auth": "Fehler beim Laden der S2S-Authentifizierung",
	"Error loading secrets": "Fehler beim Laden der geheimen Schlüssel",
	"Error loading source names": "Fehler beim Laden von Quellennamen",
	"Error loading sources": "Fehler beim Laden von Quellen",
	"Error loading types": "Fehler beim Laden von Typen",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "Fehler bei der Validierung dieses Codes. Stellen Sie sicher, dass der Werbeaktionscode keine Anführungszeichen enthält.",
	Establish: Establish,
	"Estimate costs": "Kosten schätzen",
	"Estimated cost per instance": "Geschätzte Kosten pro Instanz",
	"Estimated starting cost": "Geschätzte Anfangskosten",
	"Estimated total ({{count}} instances)": "Geschätzte Gesamtzahl ({{count}} Instanzen)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Instanz von Event Notifications",
	"Event Notifications service instance": "Serviceinstanz von Event Notifications",
	"Event Source Manager": "Ereignisquellenmanager",
	"Every 2 hours": "Alle 2 Stunden",
	"Every 2 minutes": "Alle 2 Minuten",
	"Every 3 hours": "Alle 3 Stunden",
	"Every 4 hours": "Alle 4 Stunden",
	"Every 5 minutes": "Alle 5 Minuten",
	"Every 6 hours": "Alle 6 Stunden",
	"Every 10 minutes": "Alle 10 Minuten",
	"Every 15 minutes": "Alle 15 Minuten",
	"Every day": "Jeden Tag",
	"Every fifth day": "Jeden fünften Tag",
	"Every fourth day": "Jeden vierten Tag",
	"Every fourth month": "Jeden vierten Monat",
	"Every hour": "Stündlich",
	"Every minute": "Jede Minute",
	"Every month": "Jeden Monat",
	"Every second day": "Jeden zweiten Tag",
	"Every second month": "Jeden zweiten Monat",
	"Every sixth month": "Jeden sechsten Monat",
	"Every third day": "Jeden dritten Tag",
	"Every third month": "Jeden dritten Monat",
	"Examples: access:dev, proj:version-1": "Beispiele: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "Beispiele: env:dev, version-1",
	"Existing instance": "Vorhandene Instanz",
	"Exiting encryption selection": "Beenden der Verschlüsselungsauswahl",
	"Expand all rows": "Alle Zeilen erweitern",
	"Expand group": "Gruppe einblenden",
	"Expand row": "Zeile erweitern",
	"Expand summary": "Zusammenfassung einblenden",
	Expired: Expired,
	"Expired (beta)": "Abgelaufen (Beta)",
	"Expires {{when}}": "Ablaufdatum: {{when}}",
	"Expires after beta": "Läuft nach der Betaversion ab",
	"Extra large (64px)": "Besonders groß (64px)",
	"Extra small (24px)": "Besonders klein (24px)",
	Failed: Failed,
	"Failed to check permission": "Erlaubnisprüfung fehlgeschlagen",
	"Failed to create configuration": "Konfiguration konnte nicht erstellt werden",
	"Failed to create key": "Fehler beim Erstellen des Schlüssels",
	"Failed to create policy": "Richtlinie konnte nicht erstellt werden",
	"Failed to create project": "Projekt kann nicht erstellt werden",
	"Failed to fetch": "Abrufen fehlgeschlagen",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "Abrufen von IBM Cloud Activity Tracker-Instanzen fehlgeschlagen.",
	"Failed to fetch IBM Cloud Monitoring instances.": "Abrufen von IBM Cloud Monitoring-Instanzen fehlgeschlagen.",
	"Failed to fetch IBM Log Analysis instances.": "Abrufen von IBM Log Analysis-Instanzen fehlgeschlagen.",
	"failure state": "Fehlerstatus",
	February: February,
	"Fetch data": "Daten abrufen",
	Filter: Filter,
	"Filter instance by region": "Instanz nach Regionen filtern",
	"Filter...": "Filtern ...",
	Filters: Filters,
	"Filters:": "Filter:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "Cluster wird fertiggestellt ...",
	"Finalizing workers...": "Worker werden abgeschlossen...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "IBM Cloud Activity Tracker ermöglicht Ihnen operative Einblicke in Ihre Cloud-Ressourcen.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "IBM Cloud Monitoring ermöglicht Ihnen operative Einblicke in Ihre Cloud-Ressourcen.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "IBM Log Analysis ermöglicht Ihnen operative Einblicke in Ihre Cloud-Ressourcen.",
	"Get started": "Erste Schritte",
	"Get started with Security and Compliance Center": "Erste Schritte mit Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "Geben Sie Ihrem Schlüssel einen Alias, um ihn später leichter wiederzufinden.",
	"Helm catalog": "Helm-Katalog",
	Help: Help,
	"Hide password": "Kennwort verbergen",
	"Host usage\n(used / total)": "Hostnutzung (genutzt / gesamt)",
	"Hosts needed": "Benötigte Hosts",
	"Hosts requirements met": "Voraussetzungen für Hosts erfüllt",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "Stunde (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "Ich bin damit einverstanden, dass mein Token verwendet wird, um in meinem Namen eine Dienst-zu-Dienst-Richtlinie zwischen dem Quelldienst {{sourceServiceDisplayName}} und dem Zieldienst {{serviceDisplayName}} zu erstellen.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "Ich bestätige, dass ich keine Plattformprotokolle von {{instance}} mehr erhalten möchte.",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "Ich bestätige, dass ich keine Plattformmetriken von {{instance}} mehr erhalten möchte.",
	"IaaS ready": "IaaS bereit",
	IAM: IAM,
	"IAM credentials": "IAM-Berechtigungsnachweise",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "Wenn kein Schlüsselring zugewiesen ist, wird die Taste dem Standardschlüsselring hinzugefügt.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "Wenn diese Option ausgewählt ist, wird das Array als Zeichenfolge \"__NOT_SET__\" gespeichert.",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "Wenn der Anfangswert kein gültiges Zeichenfolgenarray war, wird unten ein leeres oder einzelnes Elementarray angezeigt.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "Beziehen sich die Benutzertags auf die Abrechnung, kann es sinnvoll sein, Tags in Form von Schlüssel/Wert-Paaren zu verwenden. Beispiel:",
	Images: Images,
	"Import your own key": "Eigenen Schlüssel importieren",
	"In progress": "In Bearbeitung",
	"in progress state": "Status 'In Bearbeitung'",
	Inactive: Inactive,
	"inactive state": "inaktiver Status",
	Incomplete: Incomplete,
	"incomplete state": "unvollständiger Status",
	Information: Information,
	"information state": "Informationsstatus",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "Infrastrukturzonen",
	Instance: Instance,
	"Instance ID": "Instanz-ID",
	"Instance location": "Instanzposition",
	"Instance name": "Instanzname",
	"Instance(s) in {{region}}": "Instanz(en) in {{region}}",
	"Instance(s) in region": "Instanz(en) in Region",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "Interner Serverfehler. Warten Sie eine Minute und wiederholen Sie die Aktion. Wenn das Problem bestehen bleibt, öffnen Sie ein Support-Ticket.",
	"Interpolated URI": "Interpolierter URI",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "Ungültiges Datahook-Objekt, letzte gültige Option wird verwendet",
	"Invalid label name.": "Ungültiger Name für die Bezeichnung.",
	"Invalid label prefix or name.": "Ungültiges Präfix oder ungültiger Name.",
	"Invalid label value.": "Ungültiger Wert für die Bezeichnung.",
	"Items per page:": "Elemente pro Seite:",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "Schlüssel-Aliase",
	"Key CRN": "Schlüssel-CRN",
	"Key description": "Schlüsselbeschreibung",
	"Key description must be at least 2 characters and no more than 240 characters.": "Die Schlüsselbeschreibung muss mindestens 2 Zeichen und nicht mehr als 240 Zeichen umfassen.",
	"Key ID": "Schlüssel-ID",
	"Key management": "Schlüsselmanagement",
	"Key management service": "Schlüsselmanagementservice",
	"Key material": "Schlüsselmaterial",
	"Key material is required to import a key": "Schlüsselmaterial ist erforderlich, um einen Schlüssel zu importieren",
	"Key material length must be 128, 192, or 256 bits": "Die Länge des Schlüsselmaterials muss 128, 192 oder 256 Bit betragen",
	"Key material must be base64": "Das Schlüsselmaterial muss base64 sein",
	"Key name": "Schlüsselname",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Key Protect Instanzname",
	"Key ring": "Schlüsselring",
	"Key value": "Schlüsselwert",
	"Label must be of the form 'key:value'.": "Die Bezeichnung muss das Format 'Schlüssel:Wert' aufweisen.",
	"Label name must be no more than {{maxLength}} characters.": "Der Bezeichnungsname darf nicht länger sein als {{maxLength}} Zeichen.",
	"Label prefix must be a valid DNS subdomain.": "Bei dem Präfix der Bezeichnung muss es sich um eine gültige DNS-Unterdomäne handeln.",
	"Label prefix must be no more than {{maxLength}} characters.": "Das Kennsatzpräfix darf nicht mehr als {{maxLength}} Zeichen enthalten.",
	"Label value must be no more than {{maxLength}} characters.": "Bezeichnungswert darf nicht mehr als {{maxLength}} Zeichen umfassen.",
	"Large (48px)": "Groß (48px)",
	"Last modified": "Letzte Änderung",
	"Last scanned": "Letzter Scan",
	"Last updated": "Letzte Aktualisierung",
	Launch: Launch,
	"Launch activiting tracking": "Aktivierendes Tracking starten",
	"Launch in new window": "In neuem Fenster starten",
	"Launch logging": "Protokollierung starten",
	"Launch monitoring": "Überwachung starten",
	"Learn more": "Weitere Informationen",
	"learn more.": "weitere Informationen.",
	"Learn more.": "Weitere Informationen.",
	"List of actions": "Aktionsliste",
	"list of code sample types": "Liste der Codebeispieltypen",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "Ladeanzeiger",
	"Loading...": "Ladevorgang läuft...",
	"Locate by CRN within your account": "Suchen Sie nach CRN in Ihrem Konto",
	Location: Location,
	"Location summary": "Standortzusammenfassung",
	"Location:": "Standort:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "Die Protokollerfassung ist für diese Ressource bereits aktiviert",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "Die Protokollerfassung ist für diese Ressource aktiviert und wird an die in Ihrer Routing-Konfiguration festgelegten Ziele gesendet.",
	Logging: Logging,
	"Logging (error)": "Protokollierung (Fehler)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "Die Protokollierung wird für eine optimale Fehlersuche und die Reduzierung von Ausfallzeiten empfohlen",
	"Logging...": "Protokollieren...",
	London: London,
	"Looking for valid service to service authorization policy...": "Suche nach gültiger Dienst-zu-Dienst-Autorisierungspolitik...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "Sieht so aus, als fehlten Ihnen die erforderlichen Berechtigungen zum Erstellen der Richtlinie. Kontaktieren Sie Ihren Kontoverwalter",
	"Looks like you don't have access to view account information.": "Sie verfügen nicht über die Zugriffsberechtigung zum Anzeigen von Kontoinformationen.",
	"Looks like you don't have access to view the billing period": "Sie verfügen nicht über die Zugriffsberechtigung zum Anzeigen des Abrechnungszeitraums",
	"Looks like you don't have any scans": "Es sieht so aus, als hätten Sie keine Scans",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "Sie verfügen nicht über den erforderlichen Zugriff zum Anzeigen dieser Informationen. Wenden Sie sich an Ihren Kontoadministrator, um Ihre Berechtigungen zu überprüfen.",
	"Looks like you don't have the correct access": "Sie verfügen offenbar nicht über den korrekten Zugriff",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "Sie verfügen nicht über die korrekte Zugriffsberechtigung. Sie benötigen eine Zugriffsberechtigung für den Zielservice, um eine Autorisierung zwischen Services zu erstellen.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Stellen Sie sicher, dass Themen, Subskriptionen und Ziele in Event Notifications konfiguriert sind.",
	"Manage encryption by enabling a key management service (KMS).": "Verwalten Sie die Verschlüsselung, indem Sie einen Schlüsselverwaltungsdienst (KMS) aktivieren.",
	"Manage routing": "Routing verwalten",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "Verwalten Sie den Lebenszyklus Ihrer Verschlüsselungsschlüssel, die für Sie von IBM Cloud-Ressourcen, -Services und -Anwendungen verwendet werden.",
	"Managed from": "Verwaltet über",
	March: March,
	May: May,
	"Media gallery video": "Video zur Mediengalerie",
	"Medium (40px)": "Mittel (40px)",
	"Metadata location": "Standort der Metadaten",
	Metro: Metro,
	"Minimum host requirements are met.": "Die Hostmindestvoraussetzungen sind erfüllt.",
	Minute: Minute,
	"Minute (UTC)": "Minute (UTC)",
	"Missing prerequisite services": "Fehlende vorausgesetzte Services",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "Ändern Sie hier die an Ihren Datahook übergebenen Argumente.",
	"Mon-Fri": "Mo-Fr",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "Überwachen Sie alle Ihre Umgebungen auf Konformität, indem Sie Scans einrichten.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Überwachen und prüfen Sie IBM Cloud-Aktivitäten für mehr Sicherheit und Compliance. <a>Weitere Informationen</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "Monat (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "Name wird bereits verwendet. Geben Sie einen eindeutigen Namen an.",
	"Name must be between 2 and 90 characters": "Der Name muss zwischen 2 und 90 Zeichen lang sein",
	"Name this project": "Dieses Projekt benennen",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "Neue Instanz",
	Next: Next,
	"Next page": "Nächste Seite",
	"Next: Customize": "Weiter: Anpassen",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "Keine verfügbaren Katalogregionen",
	"No Cloud Object Storage instance is available.": "Es ist keine Cloud Object Storage-Instanz verfügbar.",
	"No code preview has been configured for terraform. Please visit our docs to ": "Für Terraform wurde keine Codevorschau konfiguriert. Weitere Informationen finden Sie in unseren Dokumenten unter ",
	"No configurations available": "Keine Konfigurationen verfügbar",
	"No events can be scheduled with your selected CRON expression.": "Mit dem ausgewählten CRON-Ausdruck können keine Ereignisse geplant werden.",
	"No Hyper Protect Crypto Services instances found": "Keine Hyper Protect Crypto Services Instanzen gefunden",
	"No instances found": "Keine Instanzen gefunden",
	"No item matches the filters. Clear the filters and try again.": "Kein Element entspricht den Filtern. Heben Sie die Filter auf und wiederholen Sie den Vorgang.",
	"No items available to display. Select an instance and bucket to view objects.": "Keine anzuzeigenden Elemente verfügbar. Wählen Sie eine Instanz und ein Bucket aus, um Objekte anzuzeigen.",
	"No items match the current filter.": "Es sind keine Elemente vorhanden, die mit dem aktuellen Filter übereinstimmen.",
	"No keys available": "Keine Schlüssel verfügbar",
	"No matches found. To create new tags, contact your tag administrator.": "Keine Übereinstimmungen gefunden. Wenn Sie neue Tags erstellen möchten, kontaktieren Sie den für Tags zuständigen Administrator.",
	"No matching options": "Keine übereinstimmenden Optionen",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "Für dieses Konto sind keine übereinstimmenden Regions-IDs verfügbar. Wenn Sie denken, dass dies ein Fehler ist, aktualisieren Sie die Seite oder wenden Sie sich an Ihren Administrator.",
	"No plans found": "Keine Pläne gefunden",
	"No regions available": "Keine Regionen verfügbar",
	"No resource groups available": "Keine Ressourcengruppen verfügbar",
	"No secret available": "Kein geheimer Schlüssel verfügbar",
	"No secret group available": "Keine Gruppe geheimer Schlüssel verfügbar",
	"No service instance available": "Keine Serviceinstanz verfügbar",
	"No valid version update options are available.": "Es sind keine gültigen Versionsaktualisierungsoptionen verfügbar.",
	"Non-compliant": "Nicht konform",
	None: None,
	"None available": "Keine verfügbar",
	Normal: Normal,
	"Normal (48px)": "Normal (48 px)",
	"Not authorized": "Nicht autorisiert",
	"Not ready": "Nicht bereit",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "Object",
	"Object storage": "Objektspeicher",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Der Objektspeicher wird dazu verwendet, Daten zum Standort und Sicherungskopien der Standortcluster zu speichern. <a>Weitere Informationen.</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "Einmal am Tag",
	"Once a month": "Einmal im Monat",
	"Once a week": "Einmal pro Woche",
	"Once a year": "Einmal im Jahr",
	Open: Open,
	"Open dashboard": "Dashboard öffnen",
	"Open Dashboard": "Dashboard öffnen",
	"Open menu": "Menü öffnen",
	"Open page navigation menu": "Seitennavigationsmenü öffnen",
	"Open reference picker": "Referenzpicker öffnen",
	"Open tab list": "Registerkartenliste öffnen",
	Osaka: Osaka,
	"Overflow menu": "Kontextmenü",
	"Overflow Menu": "Kontextmenü",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "Seite {{pageNumber}}",
	"Page Navigation": "Seitennavigation",
	"Page navigation menu": "Seitennavigationsmenü",
	"Page number": "Seitennummer",
	Pattern: Pattern,
	"Pay-As-You-Go": "Nutzungsabhängig",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "Plattformzugriff",
	"Platform logs from {{region}} will be sent to a new instance": "Plattformprotokolle von {{region}} werden an eine neue Instanz gesendet",
	"Platform logs from {{region}} will be sent to an existing instance": "Plattformprotokolle von {{region}} werden an eine bestehende Instanz gesendet",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "Die Plattformprotokolle von {{region}} werden an die Zielinstanz gesendet. <a>Weitere Informationen</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "Plattformprotokolle werden von aktivierten IBM Cloud-Diensten entsprechend dem definierten Routing-Bereich gesammelt.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "Vor dem Anwenden des Werbeaktionscodes eine <a>Registrierung</a> für den Erstellungsprozess oder eine <a>Anmeldung</a> durchführen.",
	"Prefix filter": "Präfixfilter",
	Premium: Premium,
	"Preparing master, workers...": "Vorbereitung der Master, Worker,...",
	"Preparing master...": "Master wird vorbereitet...",
	"Prerequisite services installed": "Installierte vorausgesetzte Services",
	Previous: Previous,
	"Previous page": "Vorherige Seite",
	"Pricing Plans": "Preisstrukturpläne",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "Geben Sie eine ausführlichere Beschreibung des Schlüssels an. Verwenden Sie zum Schutz Ihrer Privatsphäre keine personenbezogenen Daten, wie z. B. Ihren Namen oder Ihren Standort, als Beschreibung. Sie können dies nach der Schlüsselerstellung nicht ändern.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "Bietet Einblicke in die Leistung und den Zustand Ihrer mit IBM Cloud betriebenen Ressourcenanwendung.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "Bereit zur Anwendung?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Cloud Object Storage-Instanzen aktualisieren",
	"Refresh data": "Daten aktualisieren",
	"Refresh secrets": "Geheime Schlüssel aktualisieren",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "Sortierung entfernen",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "Die Wiedergabe von Änderungshooks wird nicht unterstützt, um unerwartete Ressourcenänderungen zu verhindern.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "Erstellung wird angefordert...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "Filter zurücksetzen",
	"Reset to default": "Auf Standardwert zurücksetzen",
	"Reset zoom": "Zoom zurücksetzen",
	"Resource Configuration": "Ressourcenkonfiguration",
	"Resource group": "Ressourcengruppe",
	"Resource group:": "Ressourcengruppe:",
	"Resource list": "Ressourcenliste",
	"Resource List": "Ressourcenliste",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "Nicht in den Kosten enthaltene Ressourcen",
	"Restricted access": "Eingeschränkter Zugriff",
	Results: Results,
	"Retrying delete": "Löschen wird wiederholt",
	"Retrying deploy": "Bereitstellung wird wiederholt",
	"Revert {{resetCount}} to default": "{{resetCount}} auf den Standardwert zurücksetzen",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "Zugewiesene Zugriffsberechtigungen für {{resourceDisplayName}} überprüfen",
	"Review settings in Event Notifications": "Einstellungen in Event Notifications überprüfen",
	"Review the following access group policies to ensure you're assigning the right level of access.": "Überprüfen Sie die folgenden Zugriffsgruppenrichtlinien, um sicherzustellen, dass die korrekte Zugriffsberechtigungsebene zugewiesen wird.",
	"Rotation interval": "Intervall für Rotation",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "Rotationsrichtlinien bestimmen das Intervall zwischen automatischen Schlüsselrotationen. Ein Intervall von einem Monat bedeutet beispielsweise, dass ein Schlüssel alle 30 Tage rotiert wird. Wenn die Richtlinie bereits aktiviert ist, bedeutet dies, dass eine Instanzrichtlinie für diese Instanz vorhanden ist. Wenn keine andere Aktion ausgeführt wird, wird das angezeigte Rotationsintervall auf den Schlüssel angewendet. Wenn sie inaktiviert ist, aktivieren Sie sie, um eine Richtlinie für diesen Schlüssel festzulegen.",
	"Rotation policy": "Rotationsrichtlinie",
	"Rotation policy disabled": "Rotationspolitik deaktiviert",
	"Route name": "Name der Route",
	Routing: Routing,
	"Routing scope": "Umfang der Streckenführung",
	"Row height": "Zeilenhöhe",
	"Sample not yet available": "Beispiel noch nicht verfügbar",
	"Sao Paulo": "Sao Paulo",
	"Sat-Sun": "Sa-So",
	Satellite: Satellite,
	"Satellite container": "Satellite-Container",
	"Satellite location": "Satellite-Standort",
	"Satellite location base cost": "Basiskosten für Satellite-Standort",
	"Satellite location base functionality": "Satellite -Positionsbasisfunktionalität",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "Wird gespeichert...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Schematics-Arbeitsbereiche und andere Projektdaten werden in der ausgewählten Region und Ressourcengruppe gespeichert. <a>Weitere Informationen.</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Schematics-Arbeitsbereiche werden in dieser Region bereitgestellt. Ihr Projekt kann weiterhin Ressourcen in einem beliebigen Bereich bereitstellen.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Schematics-Arbeitsbereiche werden in dieser Ressourcengruppe bereitgestellt. Ihr Projekt kann weiterhin Ressourcen in einer beliebigen Ressourcengruppe bereitstellen.",
	Search: Search,
	"Search in this instance": "Suche in diesem Fall",
	Secret: Secret,
	"Secret configured": "Geheimer Schlüssel konfiguriert",
	"Secret group": "Gruppe geheimer Schlüssel",
	"Secret type": "Typ des geheimen Schlüssels",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "Sicherer Wert",
	"See details": "Details anzeigen",
	Select: Select,
	"Select a location to see what steps you need to take next.": "Wählen Sie eine Position aus, um anzuzeigen, welche Schritte Sie als Nächstes ausführen müssen.",
	"Select a project": "Projekt auswählen",
	"Select a reference": "Referenz auswählen",
	"Select a region": "Region auswählen",
	"Select a resource group": "Wählen Sie eine Ressourcengruppe aus",
	"Select a role to determine the level of access for the source service.": "Rolle auswählen, um die Zugriffsberechtigungsebene für den Quellenservice zu bestimmen.",
	"Select a secret": "Geheimen Schlüssel auswählen",
	"Select a secret group": "Gruppe geheimer Schlüssel auswählen",
	"Select a service instance": "Serviceinstanz auswählen",
	"Select all {{totalRowCount}} items": "Alle {{totalRowCount}} Elemente auswählen",
	"Select all rows on page": "Alle Zeilen auf der Seite auswählen",
	"Select an environment": "Umgebung auswählen",
	"Select an existing configuration": "Vorhandene Konfiguration auswählen",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "IBM Cloud Monitoring-Instanz auswählen, um Plattformmetriken zu erhalten",
	"Select an IBM Log Analysis instance to receive platform logs": "IBM Log Analysis-Instanz auswählen, die Plattformprotokolle erhalten soll",
	"Select an instance": "Instanz auswählen",
	"Select an instance to show keys": "Instanz zum Anzeigen von Schlüsseln auswählen",
	"Select an option...": "Option auswählen...",
	"Select existing key": "Vorhandenen Schlüssel auswählen",
	"Select from Secrets Manager": "In Secrets Manager auswählen",
	"Select KMS instance": "KMS-Instanz auswählen",
	"Select namespaces": "Namensbereiche auswählen",
	"Select one or more namespaces": "Einen oder mehrere Namensbereiche auswählen",
	"Select one or more projects": "Ein oder mehrere Projekte auswählen",
	"Select prerequisites": "Voraussetzungen auswählen",
	"Select projects": "Projekte auswählen",
	"Select region and resource group": "Region und Ressourcengruppe auswählen",
	"Select row": "Zeile auswählen",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "Wählen Sie die <a>IBM Cloud-Region</a> aus, die am nächsten an der Position Ihrer Infrastruktur liegt, um eine niedrige Netzlatenz sicherzustellen.",
	"Select the following tile to deploy it.": "Wählen Sie die folgende Kachel aus, um sie einzusetzen.",
	"Send all audit events from enabled resources in {{region}}.": "Senden aller Audit-Ereignisse von aktivierten Ressourcen in {{region}}.",
	"Send all available audit events in this account.": "Senden Sie alle verfügbaren Prüfereignisse in diesem Konto.",
	"Send events to": "Ereignisse senden an",
	"Send logs to": "Protokolle senden an",
	"Send test notification": "Testbenachrichtigung senden",
	Sending: Sending,
	"Sent!": "Gesendet!",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "Serverlose Projekte",
	Service: Service,
	"Service access": "Servicezugriff",
	"Service authorization": "Serviceautorisierung",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "Die Dienstautorisierung ist erforderlich, damit Activity Tracker Event Routing mit Cloud Logs kommunizieren kann. Klicken Sie auf <span>Jetzt autorisieren</span>, um eine Richtlinie zu erstellen, die für alle Cloud Logs-Ressourcen in diesem Konto gilt.",
	"Service authorization required": "Serviceautorisierung erforderlich",
	"Service instance": "Serviceinstanz",
	"Service name": "Servicename",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "Für Ihre Instanz muss Service-zu-Service-Autorisierung bereitgestellt werden. <a>Weitere Informationen</a>",
	"Service to service authorization policy found": "Dienst-zu-Dienst-Autorisierungsrichtlinie gefunden",
	"Service to service authorization policy needed": "Erforderliche Genehmigungspolitik von Dienst zu Dienst",
	"Service type": "Servicetyp",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "Die Autorisierung zwischen Services konnte nicht überprüft werden. Fügen Sie die erforderlichen Rollen manuell hinzu und überprüfen Sie sie.",
	"Service-to-service authorization requirements are met.": "Die Voraussetzungen für die Autorisierung zwischen Services sind erfüllt.",
	"Set an interval (in months)": "Intervall festlegen (in Monaten)",
	"Set key rotation policy": "Richtlinie für Schlüsselrotation festlegen",
	"Set up auth": "Authentifizierung einrichten",
	Settings: Settings,
	"Short (32px)": "Niedrig (32 px)",
	"Show all filters": "Alle Filter anzeigen",
	"Show code sample": "Codebeispiel anzeigen",
	"Show environments information": "Umgebungsinformationen anzeigen",
	"Show error information": "Fehlerinformationen anzeigen",
	"Show information": "Informationen anzeigen",
	"Show less": "Reduzieren",
	"Show more": "Mehr anzeigen",
	"Show more details": "Weitere Details anzeigen",
	"Show password": "Kennwort anzeigen",
	"Show tooltip": "QuickInfo anzeigen",
	"Showing {{count}} item": "Element {{count}} anzeigen",
	"Showing {{count}} items": "{{count}} Elemente anzeigen",
	Size: Size,
	"Small (32px)": "Klein (32px)",
	"Some events from {{serviceName}}:": "Einige Ereignisse von {{serviceName}}:",
	"Something went wrong": "Ein Fehler ist aufgetreten.",
	"Something went wrong.": "Es ist ein Fehler aufgetreten.",
	"Something went wrong. Try reloading the page to see this information": "Es ist ein Fehler aufgetreten. Laden Sie die Seite erneut, um diese Informationen anzuzeigen",
	Sort: Sort,
	"Sort ascending": "In aufsteigender Reihenfolge sortieren",
	"Sort descending": "In absteigender Reihenfolge sortieren",
	Source: Source,
	"Source Details": "Quellendetails",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "Die Quelle für den Service ist in der Event Notifications-Instanz nicht vorhanden. Wenden Sie sich an den zuständigen Administrator.",
	"Source service": "Quellenservice",
	"Specific namespaces not supported": "Bestimmte Namensbereiche ohne Unterstützung",
	"Specific projects not supported": "Bestimmte Projekte ohne Unterstützung",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "Erstellen Sie als ersten Schritt einen geeigneten Cluster für die Ausführung Ihrer Workloads.",
	"Start date": "Startdatum",
	"Starting at": "Beginnt um",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "Die Anfangskosten basieren auf dieser Ressourcenkonfiguration. Sie können Konfigurationen bearbeiten, nachdem Sie dieses Produkt zu einem Projekt hinzugefügt haben, was sich auf die Kosten auswirken kann.",
	State: State,
	Status: Status,
	"status icon": "Statussymbol",
	"Stay in pattern": "Im Muster bleiben",
	"Steps complete": "Schritte abgeschlossen",
	Storage: Storage,
	"Storage bucket (optional)": "Speicherbucket (optional)",
	"Storage configuration missing": "Speicherkonfiguration fehlt",
	"Storage ready": "Speicher bereit",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "Speichern, suchen, analysieren, überwachen und alarmieren Sie Ihre IBM Cloud-Protokolldaten und -Ereignisse.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "Erfolgsstatus",
	"Success! This promotion was applied to your account.": "Erfolgreich! Dieser Werbeaktionscode wurde für Ihr Konto angewendet.",
	"Successfully created new Key Protect instance": "Erfolgreich eine neue Key Protect-Instanz erstellt",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "Supportplan",
	"Switch to folders view": "Zur Ordneransicht wechseln",
	"Switch to objects view": "Zur Objektansicht wechseln",
	Sydney: Sydney,
	"Syntax: ": "Syntax: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "Der Tag '{{tagName}}' konnte nicht erstellt werden, da der Name ungültig ist.",
	tags: tags,
	Tags: Tags,
	"Tags:": "Tags:",
	"Tags: (optional)": "Tags: (optional)",
	"Tall (64px)": "Hoch (64 px)",
	"Target destination": "Ziel",
	"Target location": "Zielposition",
	"Target name": "Zielname",
	"Target selected": "Ziel ausgewählt",
	"Target service instance": "Zielserviceinstanz",
	"Target type": "Zieltyp",
	"Template error": "Vorlagenfehler",
	"Terms and conditions": "Vertragsbedingungen",
	"Test notification": "Alertbenachrichtigung",
	"The address field is required.": "Das Adressfeld ist erforderlich.",
	"The catalog window might have been blocked from opening.": "Möglicherweise wurde das Öffnen des Katalogfensters blockiert.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "Die verbundene Event Notifications -Instanz wurde aus dem Konto gelöscht. Wenn Sie weiterhin Benachrichtigungen verwenden möchten, trennen Sie die aktuelle Instanz, indem Sie auf Verbindung trennen (Verbindung) klicken. (Verbindung trennen). Schließen Sie anschließend eine andere Event Notifications -Instanz an.",
	"The description should not contain any leading or trailing whitespace characters.": "Die Beschreibung darf keine führenden oder abschließenden Leerzeichen enthalten.",
	"The description should not exceed {{limit}} characters in length.": "Die Länge der Beschreibung sollte {{limit}} Zeichen nicht überschreiten.",
	"The following access is required:": "Der folgende Zugriff ist erforderlich:",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "Die folgende Codevorschau zeigt die entsprechende Anforderung als CLI-Befehle an. Verwenden Sie sie als Ausgangspunkt zum Schreiben Ihrer eigenen Automatisierung. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "Die folgende Codevorschau zeigt die entsprechende Anforderung als REST-API-Aufrufe an. Verwenden Sie sie als Ausgangspunkt zum Schreiben Ihrer eigenen Automatisierung. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "Die folgende Codevorschau zeigt die entsprechende Anforderung mit Terraform an. Verwenden Sie sie als Ausgangspunkt zum Schreiben Ihrer eigenen Automatisierung. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "Die folgende Vorschau zeigt die entsprechende Anforderung als Code an. Verwenden Sie sie als Ausgangspunkt zum Schreiben Ihrer eigenen Automatisierung.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "Die folgenden Ressourcen waren nicht in der Kostenschätzung enthalten, können aber zu damit verbundenen Kosten führen.",
	"The IAM role manager for {{serviceName}}": "Der IAM-Rollenmanager für {{serviceName}}",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "Auf die Instanz kann nicht zugegriffen werden, weil ein Service zur Serviceautorisierung aus dem Konto entfernt wurde. Erstellen Sie eine Berechtigung mit Ereignisquellenmanager-Zugriff zwischen {{sourceServiceName}} und Event Notifications.",
	"The list of namespaces can't be populated. Try again later.": "Die Liste der Namensbereiche kann nicht gefüllt werden. Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
	"The list of projects can't be populated. Try again later.": "Die Liste der Projekte kann nicht gefüllt werden. Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
	"The name is required.": "Der Name ist erforderlich.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "Der Name darf höchstens {{max}} Zeichen lang sein, muss mit einem Buchstaben beginnen und darf nur alphanumerische Zeichen, '-' und '.' enthalten.",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "Der Name eines Namensbereichs darf nur Kleinbuchstaben, Zahlen und in Gedankenstriche enthalten. Der Name darf nicht mit einem Gedankenstrich beginnen oder enden und kann maximal 63 Zeichen enthalten.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "Der Name eines Projekts darf nur Kleinbuchstaben, Zahlen und in Gedankenstriche enthalten. Der Name darf nicht mit einem Gedankenstrich beginnen oder enden und kann maximal 63 Zeichen enthalten.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "Der Name darf nur alphanumerische Zeichen, Unterstreichungszeichen, Gedankenstriche und Leerzeichen enthalten.",
	"The name should not contain any special characters.": "Der Name darf keine Sonderzeichen enthalten.",
	"The name should not exceed {{limit}} characters in length.": "Der Name sollte nicht länger als {{limit}} Zeichen sein.",
	"The region is required.": "Die Region ist erforderlich.",
	"The resource group is required.": "Die Ressourcengruppe ist erforderlich.",
	"The resource group window might have been blocked from opening.": "Möglicherweise wurde das Öffnen des Ressourcengruppenfensters blockiert.",
	"The tag name must be in a key:value format": "Der Tagname muss das Format 'Schlüssel:Wert' aufweisen.",
	"The tag name must be in a key:value format.": "Der Tagname muss ein Schlüssel: Wert-Format haben.",
	"The window might have been blocked from opening.": "Möglicherweise wurde das Öffnen des Fensters blockiert.",
	"There was a problem loading resource groups.": "Beim Laden der Ressourcengruppen ist ein Problem aufgetreten.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "Diese Rollen ermöglichen den Zugriff für die Verwendung des Service und für die Ausführung von Service-API-Aufrufen. Jede Rolle wird vom ausgewählten Service angepasst. Wählen Sie alle aus, die gültig sind. Weitere Informationen finden Sie in der Dokumentation des Service.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "Diese Rollen werden von Administratoren im Konto erstellt, um das Zuweisen von Zugriffsberechtigungen für den Service anzupassen. Klicken Sie auf das Symbol der Aktionen für die Rolle, um die dieser Rolle zugeordneten Aktionen anzuzeigen.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "Diese ermöglichen das Ausführen von Aktionen für Plattformressourcen, zum Beispiel das Erstellen einer Instanz, das Verbinden von Instanzen mit Apps oder das Zuordnen von Benutzerzugriff. Wählen Sie alle aus, die gültig sind.",
	"This field is required": "In diesem Feld ist eine Eingabe erforderlich.",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "Dies wird derzeit nicht bei der Übergabe gesendet und es steht eine Aktualisierung des für die API verantwortlichen Teams an.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "So wird Ihre {{serviceName}}-Instanz in Event Notifications referenziert",
	"This project name \"{{name}}\" already exists, please choose another name.": "Dieser Projektname \"{{name}}\" existiert bereits, bitte wählen Sie einen anderen Namen.",
	"This section is under construction, come back later.": "Dieser Abschnitt befindet sich im Aufbau, kommen Sie später zurück.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "Dieser Service erfordert zusätzlichen Speicher, der dem Cluster zugewiesen ist. Es ist keine übereinstimmende Speicherkonfiguration vorhanden.",
	"This tag already exists. Choose another name for your tag.": "Dieser Tag ist bereits vorhanden. Wählen Sie einen anderen Namen für Ihren Tag.",
	"This value already exists.": "Dieser Wert ist bereits vorhanden.",
	"This view is not available for some account types": "Diese Ansicht ist für einige Kontotypen nicht verfügbar.",
	"Three zone names are required": "Es sind drei Zonennamen erforderlich.",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "Gehen Sie folgendermaßen vor, um die HPCS-Verschlüsselung hinzuzufügen:",
	"To connect, the instance in this region must be configured for platform": "Um eine Verbindung herzustellen, muss die Instanz in dieser Region für die Plattform konfiguriert werden",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "Um die Benachrichtigungen über die von {{serviceName}} erzeugten Ereignisse zu kontrollieren, verbinden Sie sich mit einer Event Notifications-Instanz. <a>Weitere Informationen</a>",
	"To create a new HPCS key, follow the steps below...": "Um einen neuen HPCS-Schlüssel zu erstellen, gehen Sie wie folgt vor...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "Gesamte Konten",
	"Total estimated cost": "Gesamte geschätzte Kosten",
	"Transaction ID": "Transaktions-ID",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "Versuchen Sie es später noch einmal, oder wenden Sie sich an Ihren Kontoadministrator.",
	"Try again later.": "Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Versuchen Sie, die Seite zu aktualisieren, und wiederholen Sie dann die Aktion, um festzustellen, ob das Problem bestehen bleibt. Wenn dies der Fall ist, stellen Sie sicher, dass Sie einen <a>unterstützten Browser</a> verwenden, und überprüfen Sie auf der <a>Statusseite</a>, ob etwas anderes ausgeführt wird. Wenn das Problem weiterhin auftritt, fordern Sie beim <a>Support</a> Unterstützung an.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Warten Sie einige Minuten und wiederholen Sie dann die Aktion, um festzustellen, ob das Problem weiterhin besteht. Ist dies der Fall, überprüfen Sie, ob auf der <a>Statusseite</a> weitere Vorgänge angezeigt werden. Wenn das Problem weiterhin auftritt, fordern Sie beim <a>Support</a> Unterstützung an.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "Geben Sie \"{{clusterName}}\" zur Bestätigung ein",
	"Type \"{{name}}\" to confirm": "Geben Sie zur Bestätigung \"{{name}}\" ein.",
	"Unable to configure activity tracker event routing.": "Die Ereignisweiterleitung des Activity Trackers kann nicht konfiguriert werden.",
	"Unable to configure Activity Tracker integration.": "Die Activity Tracker Integration kann nicht konfiguriert werden.",
	"Unable to configure Logging integration.": "Die Logging-Integration kann nicht konfiguriert werden.",
	"Unable to configure logging.": "Die Protokollierung kann nicht konfiguriert werden.",
	"Unable to connect your service to Event Notifications service. Try again later.": "Ihr Service kann nicht mit dem Event Notifications-Service verbunden werden. Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
	"Unable to create authorization policy.": "Die Berechtigungsrichtlinie kann nicht erstellt werden.",
	"Unable to create Satellite location": "Satellite-Position kann nicht erstellt werden",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "Erstellen der Service-zu-Service-Richtlinie derzeit nicht möglich. Aktualisieren Sie die Seite oder wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.",
	"Unable to delete cluster": "Cluster kann nicht gelöscht werden",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Die Verbindung zur Event Notifications-Instanz kann nicht getrennt werden. Aktualisieren Sie die Seite oder wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.",
	"Unable to get cluster data": "Clusterdaten können nicht abgerufen werden",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Details zur Event Notifications-Instanz können nicht abgerufen werden. Aktualisieren Sie die Seite oder wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.",
	"Unable to get storage instances.": "Speicherinstanzen können nicht abgerufen werden.",
	"Unable to list clusters.": "Auflisten der Cluster nicht möglich.",
	"Unable to list locations.": "Auflisten der Standorte nicht möglich.",
	"Unable to load Activity Tracker service catalog data": "Activity Tracker Dienstkatalogdaten können nicht geladen werden",
	"Unable to load Cloud Logs service catalog data": "Cloud Logs-Servicekatalogdaten können nicht geladen werden",
	"Unable to load cluster details.": "Clusterdetails können nicht geladen werden.",
	"Unable to load cluster update version options.": "Die Versionsoptionen für die Clusteraktualisierung können nicht geladen werden.",
	"Unable to load event routing settings": "Einstellungen für Ereignisrouting können nicht geladen werden",
	"Unable to load event routing target instances": "Zielinstanzen für die Ereignisweiterleitung können nicht geladen werden",
	"Unable to load event routing target instances.": "Event-Routing-Zielinstanzen können nicht geladen werden.",
	"Unable to load event routing targets": "Event-Routing-Ziele können nicht geladen werden",
	"Unable to load event routing targets.": "Event-Routing-Ziele können nicht geladen werden.",
	"Unable to load IBM Cloud locations data": "IBM Cloud Standortdaten können nicht geladen werden",
	"Unable to load logging instances": "Logging-Instanzen können nicht geladen werden",
	"Unable to load logging instances.": "Protokollierungsinstanzen können nicht geladen werden.",
	"Unable to load logging service catalog data": "Katalogdaten des Protokollierungsdienstes können nicht geladen werden",
	"Unable to load logs routing targets": "Protokolle für Routing-Ziele können nicht geladen werden",
	"Unable to load logs routing targets.": "Routing-Ziele können keine Protokolle laden.",
	"Unable to perform": "Durchführung nicht möglich",
	"Unable to retrieve cluster details": "Cluster-Details können nicht abgerufen werden",
	"Unable to retrieve data": "Abrufen der Daten nicht möglich.",
	"Unable to retrieve location information.": "Standortinformationen können nicht abgerufen werden.",
	"Unable to retrieve project configurations.": "Projektkonfigurationen können nicht abgerufen werden.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Testbenachrichtigung kann nicht an Event Notifications-Instanz gesendet werden. Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Die Testbenachrichtigung kann nicht an die Event Notifications-Instanz gesendet werden. Prüfen Sie, ob in Event Notifications Themen konfiguriert sind.",
	"Unable to update cluster version.": "Die Clusterversion kann nicht aktualisiert werden.",
	Unknown: Unknown,
	"unknown state": "unbekannter Status",
	"Unselect all rows": "Auswahl für alle Zeilen aufheben",
	"Unselect row": "Auswahl für Zeile aufheben",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "Nicht unterstützte Version. Aktualisieren Sie die Version, damit Sie auch weiterhin Unterstützung erhalten.",
	"Upcoming scheduled events in your timezone": "Anstehende geplante Ereignisse in Ihrer Zeitzone",
	Update: Update,
	"Update available": "Aktualisierung verfügbar",
	"Update cluster version": "Clusterversion aktualisieren",
	"Update tags": "Tags aktualisieren",
	"Update version": "Version aktualisieren",
	"Updating...": "Aktualisierung wird durchgeführt ...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "Führen Sie ein Upgrade für Ihr Konto durch, um den Abrechnungszeitraum anzuzeigen.",
	"Usage based charges apply per gigabyte of audit events ingested.": "Nutzungsabhängige Gebühren werden pro Gigabyte der aufgenommenen Prüfungsereignisse erhoben.",
	"Usage based charges apply per gigabyte of logs ingested.": "Nutzungsabhängige Gebühren fallen pro Gigabyte der aufgenommenen Protokolle an.",
	"Usage costs": "Kosten für die Nutzung",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "Verwenden Sie einen geheimen Schlüssel, um Ihre Berechtigungsnachweise für die Authentifizierung sicher und zentral zu verwalten. <a>Weitere Informationen</a>",
	"Use a secret?": "Geheimen Schlüssel verwenden?",
	"Use existing": "Vorhandene verwenden",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "Verwenden Sie Schlüsselalias, um Ihre Schlüssel leicht zu identifizieren. Ein Schlüsselalias ist ein eindeutiger und leicht erkennbarer angepasster Name.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "Ressourcen mithilfe von Tags organisieren. Falls sich die Benutzertags auf Abrechnungen beziehen, empfiehlt es sich, Tags in Form von Schlüssel:Wert-Paaren zu verwenden, um das Gruppieren zusammengehörender Tags zu vereinfachen. Beispiel:",
	"Use the options below to choose the item that the reference will be created for.": "Verwenden Sie die folgenden Optionen, um das Element auszuwählen, für das die Referenz erstellt wird.",
	"User evaluation required": "Benutzerbewertung erforderlich",
	"User permissions failure": "Fehler bei den Benutzerberechtigungen",
	"User tags": "Benutzertags",
	"User tags (optional": "Benutzertags (optional)",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "Benutzertags sind im gesamten Konto sichtbar. Verwenden Sie im Tagnamen keine sensiblen Daten.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "Der Wert muss ein gültiges Array sein (z. B. [\"array\"]). Verwenden Sie \"__NOT_SET__\", um ein Nullarray anzugeben",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "Überprüfen Sie, ob die folgenden Services an der Position installiert wurden: {{missingServices}}",
	Version: Version,
	View: View,
	"View all": "Alles anzeigen",
	"View audit events": "Audit-Ereignisse anzeigen",
	"View docs": "Dokumente anzeigen",
	"View error information": "Fehlerinformationen anzeigen",
	"View logging": "Ansicht Protokollierung",
	"View-only mode": "Nur-Anzeige-Modus",
	"VPC Gen1": "VPC der 1. Generation",
	"VPC Gen2": "VPC Gen2",
	Warning: Warning,
	"warning state": "Warnstatus",
	"Washington DC": "Washington, D.C.",
	Wednesday: Wednesday,
	"What you will need:": "Was Sie benötigen:",
	"What's the purpose of this project?": "Was ist der Zweck dieses Projekts?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "Wenn Sie den Cluster löschen, werden alle Workerknoten, Apps und Container dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden. Bevor Sie fortfahren, sichern Sie auf jeden Fall alle erforderlichen Daten- und Konfigurationsdateien.",
	"Worker count": "Anzahl der Worker",
	Workloads: Workloads,
	"Wrong Syntax": "Falsche Syntax",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "Ein Standort mit diesem Namen ist bereits vorhanden. Geben Sie einen eindeutigen Namen ein.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Sie haben bereits eine Instanz von Security and Compliance Center. Um Ergebnisse anzuzeigen, müssen Sie Ihren ersten Scan planen, indem Sie einen Anhang erstellen.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "Sie können diese Richtlinie aufgrund Ihrer Zugriffsberechtigungsebene für die Ressource der Richtlinie nicht ändern. Wenn Sie Änderungen vornehmen möchten, wenden Sie sich an den Administrator, damit dieser Ihre Zugriffsberechtigung für die Ressource aktualisiert.",
	"You can find a list of resources here once you create them.": "Nach der Erstellung finden Sie hier eine Liste der Ressourcen.",
	"You can find your resource details here after you create them.": "Sie finden Ihre Ressourcendetails hier, nachdem Sie sie erstellt haben.",
	"You can find your resources here after you create them.": "Nach der Erstellung der Ressourcen werden diese hier angezeigt.",
	"You can find your Satellite locations here after you create them.": "Nach der Erstellung der Satellite-Standorte werden diese hier angezeigt.",
	"You do not have access to any resource groups.": "Sie verfügen nicht über Zugriffsberechtigungen für eine Ressourcengruppe.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "Sie verfügen nicht über Zugriffsberechtigungen für eine Ressourcengruppe. <a>Erstellen</a> einer Ressourcengruppe.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "Sie haben keine Berechtigung zum Bearbeiten von Tags. Wenden Sie sich an Ihren Administrator, wenn Sie umfassenderen Zugriff benötigen.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "Sie haben nicht den richtigen Zugriff, um eine Konfiguration in \"{{project}}\" hinzuzufügen",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "Sie haben eingeschränkten Zugriff und können möglicherweise keine Tags hinzufügen oder entfernen. Wenden Sie sich an Ihren Administrator, wenn Sie umfassenderen Zugriff benötigen.",
	"You haven't connected an Event Notifications service instance yet.": "Sie haben noch keine Serviceinstanz für Event Notifications verbunden.",
	"You may also <a>create an instance</a>.": "Sie können auch eine <a>Instanz erstellen</a>.",
	"You may also create a new one.": "Sie können auch eine neue erstellen.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "Möglicherweise sind kontextbasierte Einschränkungen oder IAM-Richtlinien aktiviert. Wenden Sie sich an den Kontoadministrator.",
	"You must have at least one active root key. Try creating a new one.": "Sie müssen mindestens einen aktiven Rootschlüssel haben. Versuchen Sie, einen neuen zu erstellen.",
	"You need at least 1 topic to send a test notification.": "Sie benötigen mindestens 1 Thema, um eine Testbenachrichtigung zu senden.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "Sie benötigen die Rolle „Editor“ oder „Administrator“ für den IBM Cloud-Projektservice für dieses Projekt. <a>Weisen Sie sich selbst Zugriff zu</a> oder fordern Sie Zugriff von Ihrem Kontoadministrator an.",
	"You're adding tags to:": "Tags hinzufügen zu:",
	"You're editing tags for:": "Tags bearbeiten für:",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "Sie sind nicht berechtigt, eine Verbindung zu dieser Instanz herzustellen. Überprüfen Sie Ihre Berechtigungen oder wenden Sie sich an Ihren Administrator.",
	"You're using the newest version of the API server. There are no updates available at this time.": "Sie verwenden die neueste Version des API-Servers. Derzeit sind keine Aktualisierungen verfügbar.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "Sie haben die maximale Anzahl an Tags erreicht, die Sie gleichzeitig zuordnen können. Wenn Sie weitere Tags hinzufügen möchten, speichern Sie zuerst die Änderungen.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "Ihr API-Server wird auf die Version {{version}} aktualisiert. Im Anschluss daran können Sie Ihre Workerknoten auf dieselbe Version aktualisieren.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "Bild vergrößern",
	"Zoom out image": "Bild verkleinern"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, de as default, hour, hr, mo, more, provided, region, resources, tag, tags };
